<template>
  <section class="text-center mb-20 pt-12">
    <div class="max-w-4xl mx-auto">

      <!-- 主标题 -->
      <h1 class="text-5xl md:text-7xl font-bold mb-6 bg-gradient-to-r from-psychology-primary via-psychology-secondary to-psychology-primary bg-clip-text text-transparent">
        年上年下恋爱倾向测试
      </h1>

      <!-- 描述 -->
      <p class="text-xl text-gray-600 mb-10 leading-relaxed max-w-3xl mx-auto">
        通过40道深度心理学问题，从成熟偏好、照顾需求、引导欲望、独立倾向四个维度全面分析，
        精准评估你的AYP指数，揭示你的年上年下恋爱人格类型和依恋模式。
      </p>

      <!-- 主要按钮 -->
      <div class="flex flex-col sm:flex-row gap-4 justify-center items-center mb-14">
        <button
          @click="handleStartAssessment"
          class="btn-primary px-10 py-4 text-lg font-semibold bg-gradient-to-r from-psychology-primary to-psychology-secondary text-white rounded-lg hover:shadow-2xl transition-all inline-flex items-center gap-3"
        >
          <span class="text-2xl">💕</span>
          <span>开始测试</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5">
            <path d="M5 12h14"></path>
            <path d="m12 5 7 7-7 7"></path>
          </svg>
        </button>
      </div>

      <!-- 特色数据展示 -->
      <div class="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
        <div class="text-center p-5 bg-white/90 backdrop-blur-sm rounded-2xl border-2 border-psychology-primary-10 shadow-lg hover:shadow-xl transition-all">
          <div class="text-3xl mb-2">⏱️</div>
          <div class="text-2xl font-bold text-psychology-primary">8-12分钟</div>
          <div class="text-sm text-gray-600 mt-1">完成测试</div>
        </div>
        <div class="text-center p-5 bg-white/90 backdrop-blur-sm rounded-2xl border-2 border-yellow-100 shadow-lg hover:shadow-xl transition-all">
          <div class="text-3xl mb-2">📝</div>
          <div class="text-2xl font-bold text-yellow-600">40题</div>
          <div class="text-sm text-gray-600 mt-1">深度问题</div>
        </div>
        <div class="text-center p-5 bg-white/90 backdrop-blur-sm rounded-2xl border-2 border-psychology-primary-10 shadow-lg hover:shadow-xl transition-all">
          <div class="text-3xl mb-2">🎯</div>
          <div class="text-2xl font-bold text-psychology-primary">4维度</div>
          <div class="text-sm text-gray-600 mt-1">全面分析</div>
        </div>
        <div class="text-center p-5 bg-white/90 backdrop-blur-sm rounded-2xl border-2 border-orange-100 shadow-lg hover:shadow-xl transition-all">
          <div class="text-3xl mb-2">💝</div>
          <div class="text-2xl font-bold text-orange-600">5种</div>
          <div class="text-sm text-gray-600 mt-1">人格类型</div>
        </div>
      </div>

      <!-- 恋爱元素展示 -->
      <!-- <div class="mt-12 text-7xl animate-bounce-slow">
        💕 💝 💖 💗 💓 💞 💘 💌
      </div> -->
    </div>

    <!-- 激活码验证对话框 -->
    <ActivationCodeDialog 
      :show="showActivationDialog"
      :target-route="targetRoute"
      @close="handleActivationClose"
    />
  </section>
</template>

<script>
import { isActivated } from '@/utils/activationUtils'
import ActivationCodeDialog from './ActivationCodeDialog.vue'

export default {
  name: 'HeroSection',
  components: {
    ActivationCodeDialog
  },
  data() {
    return {
      showActivationDialog: false,
      targetRoute: ''
    }
  },
  methods: {
    handleStartAssessment() {
      // 检查是否已激活
      if (isActivated()) {
        // 已激活，直接跳转到测试类型选择页
        this.$router.push('/assessment/select-type')
      } else {
        // 未激活，显示激活码对话框
        this.targetRoute = '/assessment/select-type'
        this.showActivationDialog = true
      }
    },
    
    handleActivationClose() {
      this.showActivationDialog = false
    }
  }
}
</script>

<style scoped>
.btn-primary:hover {
  transform: translateY(-3px);
}

.btn-primary:active {
  transform: translateY(0);
}

@keyframes bounce-slow {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

.animate-bounce-slow {
  animation: bounce-slow 3s ease-in-out infinite;
}
</style>
